//Harpra access
export default {
    clientid: process.env.VUE_APP_AUTH_CLIENTID,
    authority: process.env.VUE_APP_AUTH_AUTHORITY,
    scopes: [
        process.env.VUE_APP_AUTH_SCOPE
    ]
}